import React from "react";
import { FiChevronsRight } from "react-icons/fi";
import logo from "./assets/logo.png"
import { fontstyle1,fontstyle2 } from "./utils/fonts";
import ColorTheme from "./utils/colors";
import ThemeContext from "./context";
import instance from "./utils/aixos"


const Content = () =>{
    const [email,setEmail] = React.useState("")
    const [loading,setLoading] = React.useState(false);
    const {theme} = React.useContext(ThemeContext);
    const colortheme = theme === "light" ?ColorTheme.light:ColorTheme.dark;

    const handleSubmit = () =>{
        setLoading(true)
        const x = document.getElementById("email").value;
        var atposition=x.indexOf("@");  
        var dotposition=x.lastIndexOf(".");  
        if (atposition<1 || dotposition<atposition+2 || dotposition+2>=x.length){  
            alert("enter the valid email id")
            setLoading(false)
        }
        else{
            instance.post("/notifyuser",{email:email}).then((res) => {
                document.getElementById("email").value = res.data.message
                setLoading(false)
              })
              .catch((err) => {
                console.log(err);
              });
        }  
    } 

    return(
        <div className="w-full flex flex-col items-center justify-center">
            <img src={logo} alt="logo"/>
            <p className="w-[300px] sm:w-[500px] text-center text-xl mt-10" style={fontstyle1}>The place where you can buy/sell your side-projects, saas and get best bidding for your projects</p>
            <p className="text-xl mt-10" style={fontstyle2}>Coming Soon</p>
            <div className="mt-20 flex flex-col sm:flex-row items-center gap-3">
                <input type="email" placeholder="Email Id" id="email" className={`w-72 p-2 border-[${colortheme.background}] bg-transparent border-2 rounded`} onChange={e => setEmail(e.target.value)}/>
                <div onClick={handleSubmit} className={` ${theme === "light" ? "bg-[#101426] text-white" : "bg-white text-[#101426]" } w-32 p-2 rounded-md flex items-center justify-center gap-3 font-medium cursor-pointer`} style={fontstyle2}>
                   {loading===true?
                   <svg
                   class={`animate-spin h-5 w-5 ${theme === "light" ? "text-red-800" : " text-[#101426]" }`}
                   xmlns="http://www.w3.org/2000/svg"
                   fill="none"
                   viewBox="0 0 24 24"
                 >
                   <circle
                     class="opacity-25"
                     cx="12"
                     cy="12"
                     r="10"
                     stroke="currentColor"
                     stroke-width="4"
                   ></circle>
                   <path
                     class="opacity-75"
                     fill="currentColor"
                     d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                   ></path>
                 </svg>
                 :""}
                    <input type="submit" value="Notify" className="cursor-pointer" />
                    <div className="text-lg cursor-pointer">
                    <FiChevronsRight/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Content;